import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import Check from '@material-ui/icons/Check';
import Lock from '@material-ui/icons/Lock';
import PlayArrow from '@material-ui/icons/PlayArrow';

import { translate } from 'services/i18nService';
import ControlledFeatureService from 'services/ControlledFeatureService';
import FanClubStore from 'stores/FanClubStore';
import MyShopStore from 'stores/MyShopStore';
import ProfileStore from 'stores/ProfileStore';
import { generateID } from 'utils/helpers';
import APIStates from 'enum/APIStates';
import allUserGroups from 'enum/userGroups';

import FanClubIcon from '../../../images/icon-fanclub.png';
import IconTokns from '../../../images/profilePage/icon-tokns.png';

import styles from './MyShopItem.css';


// eslint-disable-next-line complexity
const MyShopThumbnail = (props) => {
  const {
    animationDone,
    desktop,
    hasAccess,
    isOverlay,
    item,
    user,
    onClick,
  } = props;

  const {
    cost,
    coverImageUrl,
    discountCost,
    discountEndDate,
    discountFanclubCost,
    duration,
    fanClubCost,
  } = item;

  const { videoActionState, playUrl } = MyShopStore;
  const { isFanClubActive } = FanClubStore;
  const { performerDetails } = ProfileStore;

  const { username: performerName } = performerDetails;

  const discountActive = discountEndDate && moment(discountEndDate).diff(moment(new Date())) > 0;
  const activeMyShopDiscount = ControlledFeatureService.setUser(user).has(allUserGroups.MYSHOP_DISCOUNTS);
  const discounted = activeMyShopDiscount && discountActive && discountFanclubCost > 0 && isFanClubActive;

  const loaded = videoActionState === APIStates.LOADED && isOverlay;
  const showPlay = !loaded || animationDone;
  const hasFanClubCost =
    (fanClubCost !== cost || (discountActive && discountFanclubCost > 0)) && isFanClubActive;

  const hasDiscountCost = activeMyShopDiscount && discountActive && discountCost > 0;
  const hasDiscountFanclubCost = activeMyShopDiscount && discountActive && discountFanclubCost > 0 && isFanClubActive;
  const hasActiveDiscount = activeMyShopDiscount && discountActive;

  const IDS = {
    prefix: 'hsaklwe4',
    element: 'myShopThumbnail',
    thumbnail: 'thumbnail',
    thumbnailImage: 'thumbnailImage',
  };
  const makeId = generateID(IDS.prefix, IDS.element);

  let title = undefined;
  if (fanClubCost > 0) {
    title = translate(
      'v2profile.fanclub.special.price.tooltip',
      { 0: `<strong>${performerName}</strong>` }
    );
  } else {
    title = translate(
      'v2profile.fanclub.free.tooltip',
      { 0: `<strong>${performerName}</strong>` }
    );
  }

  return (
    <div className={desktop ? styles.thumbnailDesktop : styles.thumbnail}>
      <div
        className={`${styles.thumbnailImage} ${!hasAccess ? styles.blur : ''}`}
        id={makeId(IDS.thumbnailImage)}
        style={{ backgroundImage: `url(${coverImageUrl})` }}
        onClick={onClick}
      />
      <div
        className={styles.tint}
        id={makeId(IDS.thumbnail)}
        onClick={onClick}
      >
        <div className={`${styles.success} ${loaded ? styles.fadeOut : ''}`}>
          <Check />
          <div>
            {translate('v2profile.my.shop.success')}
          </div>
        </div>
        {showPlay && (
          <div className={styles.playButton}>
            <PlayArrow />
            {!hasAccess && !playUrl && (
              <div className={styles.lock}>
                <Lock />
              </div>
            )}
          </div>
        )}
        <span className={styles.duration}>
          {duration}
        </span>
        {hasActiveDiscount && (
          <div className={styles.vidSale}>
            {translate('v2profile.my.shop.sale')}
          </div>
        )}
      </div>
      {!loaded && (
        <div className={styles.price}>
          <div className={styles.priceRegular}>
            <img alt="tokens" src={IconTokns} />
            <span className={hasDiscountCost ? styles.priceLineThrough : ''}>
              {cost > 0 ? cost : translate('profile.profile.videos.free')}
            </span>
            {hasDiscountCost && (
              <span>
                {' '}
                {discountCost}
              </span>
            )}
          </div>

          <div>
            {hasFanClubCost && (
              <div>
                <Tooltip
                  arrow={true}
                  classes={{ tooltip: styles.tooltipWrapper, arrow: styles.arrowWrapper }}
                  enterTouchDelay={10}
                  leaveTouchDelay={3000}
                  placement="bottom-start"
                  title={title}
                >
                  <div className={styles.badgeWrapper}>
                    <img
                      alt="star"
                      className={styles.fanclubStar}
                      src={FanClubIcon}
                    />
                    <span className={discounted ? styles.priceLineThrough : ''}>
                      {fanClubCost > 0 ? fanClubCost : translate('profile.profile.videos.free')}
                    </span>
                    {hasDiscountFanclubCost && (
                      <span>
                        {' '}
                        {discountFanclubCost}
                      </span>
                    )}
                  </div>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

MyShopThumbnail.propTypes = {
  user: PropTypes.object.isRequired,
  animationDone: PropTypes.bool,
  desktop: PropTypes.bool,
  hasAccess: PropTypes.bool,
  isOverlay: PropTypes.bool,
  item: PropTypes.object,
  onClick: PropTypes.func,
};

MyShopThumbnail.defaultProps = {
  user: undefined,
  animationDone: undefined,
  desktop: false,
  hasAccess: false,
  isOverlay: false,
  item: undefined,
  onClick: () => undefined,
};

export default observer(MyShopThumbnail);
